var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarChatHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4175 3.54689L3.95353 8.61072C3.21565 9.18877 3.01068 10.0491 3.00041 11.0435C2.99985 11.0974 3.0016 11.1495 3.00567 11.2033C3.04749 11.7548 3.33662 15.1249 4.4051 18.9084C4.78269 19.9615 5.6711 21 6.89334 21H17.1066C18.3289 21 19.2173 19.9615 19.5949 18.9084C20.6634 15.1249 20.9525 11.7548 20.9943 11.2033C20.9984 11.1495 21.0001 11.0974 20.9996 11.0435C20.9893 10.0491 20.7843 9.18877 20.0465 8.61072L13.5825 3.54689C12.6517 2.8177 11.3483 2.8177 10.4175 3.54689ZM15 13.75C15 15.4069 13.6569 16.75 12 16.75C10.3431 16.75 9 15.4069 9 13.75C9 12.0931 10.3431 10.75 12 10.75C13.6569 10.75 15 12.0931 15 13.75Z",
    fill: "#3E473E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarChatHomeIcon);
export default __webpack_public_path__ + "static/media/avatar_chat_home_icon.5174cfb9c11adbf34a4641c4f3f9715b.svg";
export { ForwardRef as ReactComponent };